import styled from 'styled-components';

export const SearchDishBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SearchDishBlockLabel = styled.p`
  min-width: 100px;
  margin-bottom: 0;
`;

export const RecommendedDishText = styled.p`
  margin-left: 10px;
`;
export const RecommendedDishTitle = styled.p`
  color: black;
`;

export const RecommendedDishBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const ReplaceButtonBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const DontRemmemberText = styled.p`
  color: gray;
`;

export const DishOptionsBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 20px;
  margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/NutritionCourse/AddDishModal/AddDishModalStyles.js